import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _AssetItemHistory, _FixedAssetItemDeterioration, _FixedAssetItemDevaluation, _FixedAssetItemRevaluation } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idItem: number;
}

export const FixedAssetItemDeterioration = ({ idItem }: Props) => {

    const fixeditemdeterioration = useDataBean(_FixedAssetItemDeterioration);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idItem])

    const getLista = () => {

        fixeditemdeterioration.instance.getFixedAssetItemDeteriorationCatalog(idItem).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        fixeditemdeterioration.setBean({
            IDItem: fixeditemdeterioration.bean.IDItem
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        fixeditemdeterioration.deleteItemVoid(fixeditemdeterioration.bean.IDDeterioration).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        fixeditemdeterioration.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDDeterioration', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha', property: 'InitDate', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Valor de Deterioros', property: 'DeteriorationValue', visible: true },

    ]




    return (
        <BasicPage titulo="Consultar Deterioros">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={fixeditemdeterioration.setBean} ></BasicTable>

                </div>

            </div>
        </BasicPage>
    )
}